<template lang="pug">
.neutral200
  v-row(no-gutters)
    v-col.py-2.pr-2(cols="3")
      v-card.border.rounded-lg.fill-height(outlined)
        div.text-sm.font-semibold.neutral700--text.px-3.mt-3 Sales from loyalty program
        div.d-flex.align-center.px-3.mt-3
          div.text-xs.neutral700--text All time
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.total_sales | displayPrice($currency) }}
        v-divider.my-3
        div.d-flex.align-center.px-3.mb-3
          div.text-xs.neutral700--text This month
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.this_month_sales | displayPrice($currency) }}
    v-col.py-2.px-2(cols="3")
      v-card.border.rounded-lg.fill-height(outlined)
        div.text-sm.font-semibold.neutral700--text.px-3.mt-3 Members sign up 
        div.d-flex.align-center.px-3.mt-1
          div.text-xs.neutral700--text Total
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.total_signup | displayNumber }}
        v-divider.my-1
        div.d-flex.align-center.px-3
          div.text-xs.neutral700--text This month
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.this_month_signup | displayNumber }}
        v-divider.my-1
        div.d-flex.align-center.px-3.mb-1
          div.text-xs.neutral700--text Membership rate
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ Math.floor(stats.signup_rate) }}%
    v-col.py-2.px-2(cols="3")
      v-card.border.rounded-lg.fill-height(outlined)
        div.text-sm.font-semibold.neutral700--text.px-3.mt-3(v-if="settings && settings.loyalty_system === 'stamps'") Stamps collected
        div.text-sm.font-semibold.neutral700--text.px-3.mt-3(v-if="settings && settings.loyalty_system === 'points'") Points collected
        div.d-flex.align-center.px-3.mt-1
          div.text-xs.neutral700--text Total
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.total_collected | displayNumber }}
        v-divider.my-1
        div.d-flex.align-center.px-3
          div.text-xs.neutral700--text This month
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.this_month_collected | displayNumber }}
        v-divider.my-1
        div.d-flex.align-center.px-3.mb-1
          div.text-xs.neutral700--text(v-if="settings && settings.loyalty_system === 'stamps'") Members collected stamps today
          div.text-xs.neutral700--text(v-if="settings && settings.loyalty_system === 'points'") Members collected points today
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ Math.floor(stats.today_collected_members) }}
    v-col.py-2.pl-2(cols="3")
      v-card.border.rounded-lg.fill-height(outlined)
        div.text-sm.font-semibold.neutral700--text.px-3.mt-3 Reward redemption
        div.d-flex.align-center.px-3.mt-3
          div.text-xs.neutral700--text Total
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.total_redeemed | displayNumber }}
        v-divider.my-3
        div.d-flex.align-center.px-3.mb-3
          div.text-xs.neutral700--text This month
          v-spacer
          v-progress-circular(v-if="isFetchingStats" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7(v-else) {{ stats.this_month_redeemed | displayNumber }}
  
  v-card.border.rounded-lg.pa-6.mt-2(outlined)
    v-row.pb-2.pb-md-0(no-gutters)
      v-col(cols="12" md="8")
        v-tabs(v-model="tabs" color="basic700" :height="44" active-class="font-semibold" @change="tabChanged(tabs)")
          v-tab.text-sm.font-medium.text-none {{ $t('all') }}
          v-tab.text-sm.font-medium.text-none Returning customers
          v-tab.text-sm.font-medium.text-none New customers
          v-tab.text-sm.font-medium.text-none
            span(v-if="settings && settings.loyalty_system === 'stamps'") Last stamp
            span(v-if="settings && settings.loyalty_system === 'points'") Eligible to redeem
          //- v-tab.text-sm.font-medium.text-none.px-0 Pending collections
      v-col(cols="12" md="4" align="end")
        .d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          div(v-if="!showSearchField")
            customize-column-menu(type="loyalty" :showTooltip="false" iconSize="21")
    v-divider

    loyalty-filter-row.my-4(v-if="settings" :filters.sync="filters" ref="filter" :type="settings.loyalty_system")
    .data-table
      v-data-table.mt-sm-4.pb-6(:headers="headers" :items="members" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="openMemberDrawer")
        template(v-slot:no-data)
          .mt-16
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        template(v-slot:header.checked)
          yc-checkbox(v-if="!tabs" v-model="checkAll" @change="onCheckedAll")
        template(#item.checked="{ item, index }")
          yc-checkbox(v-model="item.checked" @change="onChecked(item)")
        template(#item.phone="{ item, index }")
          div.text-sm.font-semibold.neutral700--text.underline {{ item.phone }}
        template(#item.name="{ item, index }")
          div.text-sm.neutral700--text {{ item.name }}
        template(#item.status="{ item, index }")
          y-chip(v-if="item.status === 'new'" label="New" color="blue")
          y-chip(v-if="item.status === 'returning'" label="Returning" color="green")
        template(#item.progress="{ item, index }")
          div.text-sm.neutral700--text(v-if="settings && settings.loyalty_system === 'stamps'") {{ item.collected }}/10
          div.text-sm.neutral700--text(v-if="settings && settings.loyalty_system === 'points'") {{ item.collected | displayNumber }} pts
        template(#item.time="{ item, index }")
          div.text-sm.neutral700--text {{ item.created | convertToHumanizeTime }}
        template(#item.total_spend="{ item, index }")
          div.text-sm.neutral700--text {{ item.total_spend | displayPrice($currency) }}  
        template(v-slot:item.actions="{ item, index }")
          div.d-flex.justify-end(@click.stop)
            v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
              template(#activator="{ on }")
                v-btn(icon small v-on="on")
                  v-icon mdi-dots-horizontal
              v-list.py-0
                v-list-item(@click="openMemberDrawer(item)")
                  v-list-item-title.text-sm.basic800--text View details
                v-divider
                v-list-item(@click="openCollectStampDialog(item)")
                  v-list-item-title.text-sm.basic800--text Collect stamps
                v-divider
                v-list-item(@click="openRedeemRewardDialog(item)")
                  v-list-item-title.text-sm.basic800--text Redeem rewards
                v-divider
                v-list-item(@click="openWhatsapp(item)")
                  v-list-item-title.text-sm.basic800--text WhatsApp
                v-divider
                v-list-item(@click="copyUrl(item)")
                  v-list-item-title.text-sm.basic800--text Copy loyalty link

            //- y-button(label="Loyalty link" size="xs" underline append-icon="$yzi-copy-03" icon-color="neutral700" icon-size="18" button-class="px-0" v-clipboard:copy="getLoyaltyLink(item)" @click="copyUrl")

    div.d-flex.align-center(v-if="totalCount > pageSize")
      v-spacer
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")
  div(ref="copy")

  .dialogs
    member-info-drawer(v-if="showMemberInfoDrawer" :open.sync="showMemberInfoDrawer" :member.sync="selectedMember" :settings="settings" @closed="closed" @updated="updated")
    collect-value-dialog(v-if="showCollectValueDialog" :open.sync="showCollectValueDialog" :loyaltySystem="settings.loyalty_system" :member="selectedMember" :rewards-position="rewardsPosition" @refetch="updated" @redeem="showRedeemRewardDialog = true" @closed="closed")
    redeem-reward-dialog(v-if="showRedeemRewardDialog" :open.sync="showRedeemRewardDialog" :loyaltySystem="settings.loyalty_system" :member="selectedMember" :rewards-position="rewardsPosition" @refetch="updated" @closed="closed")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import LoyaltyFilterRow from '@/components/clinic/marketing/filters/LoyaltyFilterRow.vue'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import MemberInfoDrawer from '@/components/clinic/marketing/MemberInfoDrawer.vue'
import RedeemRewardDialog from "@/components/clinic/checkout/marketing/redeem/reward/RedeemRewardDialog.vue"
import CollectValueDialog from "@/components/clinic/checkout/marketing/collecting/CollectValueDialog.vue"

export default {
  components: { LoyaltyFilterRow, CustomizeColumnMenu, MemberInfoDrawer, RedeemRewardDialog, CollectValueDialog },
  data: () => ({
    isFetching: false,
    isFetchingStats: false,
    isLoading: false,
    showSearchField: false,
    showMemberInfoDrawer: false,
    showCollectValueDialog: false,
    showRedeemRewardDialog: false,
    checkAll: false,
    searchText: null,
    selectedMember: null,
    pageSize: 20,
    totalCount: 0,
    stats: {},
    loyalty: {},
    members: [],
    selectedMembers: [],
    filters: [],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      settings: 'marketing/getMarketingSettings',
      loyaltyFields: 'clinic/getLoyaltyFields',
      storedTabs: 'marketing/getLoyaltyTabs',
      storedPage: 'marketing/getLoyaltyPage',
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const fields = this.loyaltyFields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false
      }
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item.class = 'text-table-header'
      })
      const actions = {
        text: 'Actions',
        value: 'actions',
        enable: true,
        sortable: false,
        class: 'text-table-header text-end'
      }
      return [checkbox, ...fields, actions]
      // return [checkbox, ...fields]
    },
    tabs: {
      get () { return this.storedTabs },
      set (val) { this.$store.commit('marketing/setLoyaltyTabs', val) }
    },
    currentPage: {
      get () { return this.storedPage },
      set (val) { this.$store.commit('marketing/setLoyaltyPage', val) }
    },
    rewardsPosition() {
      return this.loyalty.rewards.map(reward => reward.tier_value) || []
    },
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.fetchFirstPage()
      }
    }
  },
  mounted () {
    this.fetchStats()
    this.fetchMembers()
    this.fetchLoyalty()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMembers () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
      }
      if (this.tabs === 1) { params.statuses = 'returning' }
      if (this.tabs === 2) { params.statuses = 'new' }
      if (this.tabs === 3) { 
        if (this.settings.loyalty_system === 'stamps') {
          params.collected = 9
        } else if (this.settings.loyalty_system === 'points') {
          params.has_reward = true
        }
      }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/loyalty/${this.company.slug}/members`, { params })
        .then(resp => {
          this.members = resp.data.results.map(m => {
            return { ...m, checked: false }
          })
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchStats () {
      this.isFetchingStats = true
      this.$axios.get(`/loyalty/${this.company.slug}/stats`)
        .then(resp => {
          this.stats = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingStats = false
        })
    },
    fetchLoyalty () {
      this.isFetching = true
      this.$axios.get(`/loyalty/${this.company.slug}`)
        .then(resp => {
          this.loyalty = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchMembers()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchMembers()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    openMemberDrawer (member) {
      this.selectedMember = member
      this.showMemberInfoDrawer = true
    },
    openCollectStampDialog (member) {
      this.selectedMember = member
      this.showCollectValueDialog = true
    },
    openRedeemRewardDialog (member) {
      this.selectedMember = member
      this.showRedeemRewardDialog = true
    },
    openWhatsapp (member) {
      const phone = member.phone
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    onChecked (item) {
      if (item.checked) {
        this.selectedMembers.push(item)
      } else {
        this.checkAll = false
        this.selectedMembers = this.selectedMembers.filter(f => f.id !== item.id)
      }
    },
    onCheckedAll () {
      if (this.checkAll) {
        this.selectedMembers = this.members
        this.members.map(m => m.checked = true)
      } else {
        this.selectedMembers = []
        this.members.map(m => m.checked = false)
      }
    },
    getLoyaltyLink (member) {
      return `https://${this.company.slug}.yezza.co/loyalty/${member.pid}`
    },
    copyUrl(member) {
      let url = this.getLoyaltyLink(member)
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
    updated () {
      this.fetchStats()
      this.fetchMembers()
    },
    closed () {
      this.selectedMember = null
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.members.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>